import PublisherActions from '../../../../actions/PublisherActions';
import query from '../../../../helpers/query';
import PostbackHistoryActions from '../../../../actions/PostbackHistoryActions';

export const actions = {
    getTotalRows(state) {
        let params = query.parseToSend(state);

        PublisherActions.getTotalRows(params);
    },

    getConversions(state) {
        let params = query.parseToSend(state);

        PublisherActions.getConversions(params);
    },

    onAddPostback(state) {
        PostbackHistoryActions.addPostback({
            id: state.conversionIdForPostback,
            status: state.conversionStatusForPostback
        }, () => {

        });
    }
};
